import {createRouter, createWebHistory} from "vue-router";

export default (app) => {
    app.use(createRouter({
        history: createWebHistory(),
        routes: [
            {path: '/ru/:pathMatch(.*)', component: {}}
        ]
    }));
}
